import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { type Filters, getAllCompanies } from "./api";
import { PageOfGetCompanyDto } from "@api/structures/PageOfGetCompanyDto";

interface Options extends Partial<UseQueryOptions<PageOfGetCompanyDto>> {
  params?: Filters;
}

export const useCompaniesQuery = ({ params, ...options }: Options = {}) =>
  useQuery({
    /** Spans companies by design, so it is not keyed by the active company. */
    queryKey: ["company", params ?? {}],
    queryFn: () => getAllCompanies(params ?? {}),
    ...options,
  });
